import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HighlightOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"highlight_off"}/>
}
